// PEPPOL Status Constants for Overall Document Status
export const OVERALL_DOCUMENT_STATUS_LABELS = {
  VALIDATING: "Validating",
  VALIDATION_FAILED: "Validation Failed",
  PENDING_TRANSMISSION: "Pending Transmission",
  TRANSMITTED: "Transmitted",
  APPROVED: "Approved",
  REJECTED: "Rejected",
  TRANSMITTING: "Transmitting",
  COMPLETED: "Processed",
  PROCESSING: "Processing",
  FAILED: "Failed",
  SUCCESS: "Success",
  ERROR: "Error",
  PENDING: "Pending",
  UPLOADED: "Queued",
  UPLOAD_FAILED: "Failed",
  QUEUED: "Queued",
  PROCESSED: "Processed",
};

// Status to color mapping for overall document status
export const OVERALL_DOCUMENT_STATUS_COLORS = {
  VALIDATING: "info",
  VALIDATION_FAILED: "warning",
  PENDING_TRANSMISSION: "warning",
  TRANSMITTED: "info",
  APPROVED: "success",
  REJECTED: "error",
  TRANSMITTING: "warning",
  COMPLETED: "success",
  PROCESSING: "warning",
  FAILED: "error",
  SUCCESS: "success",
  ERROR: "error",
  PENDING: "info",
  UPLOADED: "info",
  UPLOAD_FAILED: "error",
  QUEUED: "info",
  PROCESSED: "success",
};

// Status mapping for C3 and C5 cards - maps actual statuses to display statuses
export const TRANSMISSION_STATUS_MAPPING = {
  QUEUED: { displayStatus: "QUEUED", color: "warning" },
  SUBMITTED: { displayStatus: "TRANSMITTED", color: "info" },
  MLS_RECEIVED: { displayStatus: "TRANSMITTED", color: "info" },
  MLS_SENT: { displayStatus: "TRANSMITTED", color: "info" },
  VALIDATION_ERROR: { displayStatus: "REJECTED", color: "error" },
  MLS_VALIDATION_ERROR: { displayStatus: "REJECTED", color: "error" },
  MLS_C5_TRANSMISSION_ERROR: { displayStatus: "REJECTED", color: "error" },
  MLS_C4_TRANSMISSION_ERROR: { displayStatus: "REJECTED", color: "error" },
  MLS_C3_TRANSMISSION_ERROR: { displayStatus: "TRANSMITTED", color: "info" },
  MLS_SUCCESS: { displayStatus: "APPROVED", color: "success" },
  SKIPPED: { displayStatus: "SKIPPED", color: "default" },
};

export const USER_STATUS_LABELS = {
  invited: "Invited",
  active: "Active",
  inactive: "Inactive",
};
